import { getDoc, getDocs, doc, collection } from "firebase/firestore";
import { db } from "../services/firebase";

export const getLessonContent = async (grade, week) => {
  const LessonRef = doc(db, "Lesson", `Grade${grade}`, "week", `week${week}`);
  const data = await getDoc(LessonRef);
  return data.data().Lesson;
};

export const getQuiz = async (grade, week) => {
  const LessonRef = doc(db, "Quiz", `Grade${grade}`, "week", `week${week}`);
  const data = await getDoc(LessonRef);
  return data.data().Quiz;
};

export const getQuizNumber = async (grade) => {
  const userDocId = [];
  const data = await getDocs(collection(db, "Quiz", `Grade${grade}`, "week"));
  data.docs.map((item) => userDocId.push(item.id));
  return userDocId;

  // return data.data().Quiz;
};
